import React from 'react';
import { EditDatastream, EditEvent } from '../EditDatastream';
import { DownloadTemplateReport } from '../DownloadTemplateReport';
import { applyReportPriorityChange } from '../../utils/reportPriorityPolicy';

const TemplateEditorModals = ({
    edit,
    setEdit,
    addDatastream,
    setAddDatastream,
    details,
    setDetails,
    canEditEvent,
    canEditDatastream,
    templateEvaluationData,
    setTemplateEvaluationData,
    getNextDatastreamId,
    downloadReportState,
    setDownloadReportState,
    setLoading,
    showAlert,
    reportPriorityPolicy,
    onReportPriorityChange,
}) => (
    <>
        {edit.editEvents && canEditEvent && (
            <EditEvent
                mode={edit.mode}
                close={() => setEdit((prev) => ({ ...prev, editEvents: false }))}
                event={details.events?.find((ev) => ev.id === edit.eventId)}
                setEvent={(newEvent) => setDetails((prev) => ({
                    ...prev,
                    events: prev.events?.map((ev) => (ev.id === newEvent.id ? newEvent : ev)),
                }))}
            />
        )}
        {addDatastream.addEvents && canEditEvent && (
            <EditEvent
                mode="add"
                close={() => setAddDatastream((prev) => ({ ...prev, addEvents: false }))}
                addEdit
                event={{
                    id: (details.events?.filter((ev) => ev).length ? details.events.filter((ev) => ev).length + 1 : 1),
                    name: '',
                    code: '',
                    type: '',
                    color: 'rgb(0, 0, 0)',
                    description: '',
                    notification: 0,
                    condition: 0,
                    action: 0,
                }}
                setEvent={(newEvent) => setDetails((prev) => ({
                    ...prev,
                    events: prev.events ? [...prev.events.filter((ev) => ev), newEvent] : [newEvent],
                }))}
            />
        )}
        {edit.edit && canEditDatastream ? (
            <EditDatastream
                state={edit}
                setState={setEdit}
                datastream={details.datastreams?.find((ds) => ds.id === edit.dataId)}
                setDatastream={(newDatastream) => {
                    onReportPriorityChange?.({
                        datastreamId: newDatastream.id,
                        pin: newDatastream.pin,
                        requestedPriority: newDatastream.reportPriority,
                    });
                    setDetails({
                        ...details,
                        datastreams: applyReportPriorityChange(
                            details.datastreams,
                            newDatastream,
                            reportPriorityPolicy
                        ),
                    });
                }}
                templateDatastreams={details.datastreams?.filter((ds) => ds) || []}
                templateEvaluationData={templateEvaluationData}
                setTemplateEvaluationData={setTemplateEvaluationData}
                reportPriorityPolicy={reportPriorityPolicy}
            />
        ) : null}
        {addDatastream.edit ? (
            <EditDatastream
                state={{ ...addDatastream, mode: 'edit' }}
                setState={setAddDatastream}
                datastream={addDatastream.initialDatastream || {
                    id: getNextDatastreamId(details.datastreams?.filter((ds) => ds) || []),
                    max: 0,
                    min: 0,
                    pin: '',
                    name: '',
                    sync: 0,
                    unit: '',
                    alias: '',
                    color: 'rgb(0, 0, 0)',
                    isControlled: false,
                    isRow: 0,
                    action: 0,
                    reports: 0,
                    reportPriority: Math.max(
                        0,
                        ...(details.datastreams || []).map((ds) => Number(ds?.reportPriority) || 0)
                    ) + 1,
                    thenSet: 'no thing',
                    dataType: 'string',
                    decimals: '',
                    condition: 0,
                    invalidate: 0,
                    customChart: 0,
                    defaultValue: 0,
                    enableHistory: 0,
                    automationType: '',
                    invalidateUnit: 'sec',
                    invalidateValue: 0,
                    indicator: 'custom',
                }}
                setDatastream={(newDatastream) => {
                    onReportPriorityChange?.({
                        datastreamId: newDatastream.id,
                        pin: newDatastream.pin,
                        requestedPriority: newDatastream.reportPriority,
                    });
                    setDetails((prev) => ({
                        ...prev,
                        datastreams: applyReportPriorityChange(
                            prev.datastreams,
                            newDatastream,
                            reportPriorityPolicy
                        ),
                    }));
                }}
                templateDatastreams={details.datastreams?.filter((ds) => ds) || []}
                templateEvaluationData={templateEvaluationData}
                setTemplateEvaluationData={setTemplateEvaluationData}
                reportPriorityPolicy={reportPriorityPolicy}
            />
        ) : null}
        {downloadReportState.open && (
            <DownloadTemplateReport
                state={downloadReportState}
                setState={setDownloadReportState}
                template={details}
                setLoadingReport={setLoading}
                onAlert={showAlert}
            />
        )}
    </>
);

export default TemplateEditorModals;
